import React, { useState, useMemo } from 'react'

import queryString from 'query-string'

import { GridView } from '../components/ui'

// import { ElevioIntegration } from '../components/ui/tools'

import FormControlLabel from '@material-ui/core/FormControlLabel'
import UISwitch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import ImageSearchIcon from '@material-ui/icons/ImageSearch'
import AnnouncementIcon from '@material-ui/icons/Announcement'
import _ from 'lodash'

import { withStyles, makeStyles } from '@material-ui/core/styles'

import { withRouter } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'
import { setView } from '../redux/actions/select'

import {
  formatBorderClass, getSourceDescription, getSeverityClass, onQuickFilter
} from '../utils'

import log from 'loglevel'

const StyledSwitch = withStyles({
  switchBase: {
    color: 'white',
    '&$checked': {
      color: '#A4D164'
    },
    '&$checked + $track': {
      backgroundColor: '#A4D164'
    }
  },
  checked: {},
  track: {}
})(UISwitch)

const useStyles = makeStyles(() => ({
  paperRoot: {
    backgroundColor: '#3134384a'
  },
  whiteText: {
    color: '#FFFFFF'
  },
  setFilterRoot: {
    backgroundColor: '#3984F7'
  }
}))

const CaptureGridView = props => {
  const dispatch = useDispatch()
  const classes = useStyles()

  const { captures: rxCaptures, hits: rxHits } = useSelector(state => state.violations.violations)
  const { Filter, PageCaptureLimit: PageLimit } = useSelector(state => state.selection)

  const [rcCaptures, setRcCaptures] = useState([])
  const [capturesExhausted, setCapturesExhausted] = useState(false)
  const [allChecked, setAllChecked] = useState(false)

  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageLimit])

  useMemo(() => {
    if (Array.isArray(rxCaptures) && Boolean(parsedProps.view) && typeof PageLimit === 'number' && typeof rxHits === 'number') {
      log.info('repopulating views')

      dispatch(setView('grid-view'))
      setRcCaptures(rxCaptures)
      setCapturesExhausted(((parseInt(PageLimit, 10) * (parsedProps.page - 1)) + (rxCaptures.length - 1)) > rxHits)
    }
  }, [rxCaptures, dispatch, parsedProps.view, parsedProps.page, PageLimit, rxHits])

  useMemo(() => {
    if (Array.isArray(parsedProps.captureTrgts)) {
      setAllChecked(Boolean(parsedProps.captureTrgts.length) && Boolean(rxCaptures.length) && rxCaptures.length === parsedProps.captureTrgts.length)
    }
  }, [parsedProps.captureTrgts, rxCaptures])

  const handleCheckAll = (e) => {
    e.preventDefault()

    if (Array.isArray(parsedProps.captureTrgts)) {
      if (allChecked) {
        props.history.push({
          pathname: '/captures',
          search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
        })
      } else {
        let range = []
        let min = 0
        let max = 0
        // get the range of captures given the number available and the current page
        if (rxHits === 0) {
          range = []
        } else if ((parsedProps.page * PageLimit) > rxHits) {
          min = ((parsedProps.page - 1) * PageLimit)
          max = rxHits
          range = _.range(min, max)
        } else {
          min = ((parsedProps.page - 1) * PageLimit)
          max = (parsedProps.page * PageLimit)
          range = _.range(min, max)
        }

        props.history.push({
          pathname: '/captures',
          search: `?view=grid&page=${parsedProps.page}&activeCaptures=${JSON.stringify(range)}`
        })
      }
    }
  }

  const handleQuickFilter = (map) => {
    onQuickFilter(map, dispatch, Filter)
    props.history.push({
      pathname: '/captures',
      search: '?view=grid&page=1&activeCaptures=[]'
    })
  }

  return (
    <>
      <Grid item container direction='row' justify='center' className='mt-2'>
        {
          Boolean(rcCaptures.length) && (
            <FormControlLabel
              control={<StyledSwitch checked={allChecked} onClick={handleCheckAll} className='ml-3' />}
              label={allChecked ? <span>Unselect All</span> : <span>Select All</span>}
            />
          )
        }
      </Grid>
      <Grid item container direction='row' justify='center' id='violationContainer' className='no-gutters card-row'>
        {
          rcCaptures.length
            ? rcCaptures.reduce((arr, captureInfo, index) => {
              if (captureInfo && Boolean(captureInfo.violationID)) {
                arr.push(
                  <GridView
                    key={`grid-${index}`}
                    index={index}
                    capture={captureInfo}
                    getSeverityClass={getSeverityClass}
                    formatBorderClass={formatBorderClass}
                    handleQuickFilter={handleQuickFilter}
                    getSourceDescription={getSourceDescription}
                  />
                )
              }

              return arr
            }, [])
            : (
              <Grid
                container
                direction='row'
                justify='center'
                className='w-100 mx-auto'
                style={{
                  height: '15em',
                  maxWidth: '40em',
                  marginTop: '4em'
                }}
                key='no-return-message-grid'
              >
                <Paper
                  className='w-100 mx-auto'
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  classes={{ root: capturesExhausted ? classes.setFilterRoot : classes.paperRoot }}
                  elevation={3}
                >
                  <Grid container item direction='column' justify='center' alignContent='center'>
                    <Grid container item justify='center' alignContent='center'>
                      {capturesExhausted === true
                        ? <AnnouncementIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />
                        : <ImageSearchIcon style={{ fontSize: 'xxx-large' }} color='primary' classes={{ colorPrimary: classes.whiteText }} />}
                    </Grid>
                    <Grid container item justify='center' alignContent='center'>
                      {capturesExhausted &&
                        <Typography
                          variant='h5'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          style={{ fontWeight: 'bold' }}
                          className='mt-2'
                        >
                          Heads up!
                        </Typography>}
                      <Typography
                        variant='h6'
                        color='primary'
                        classes={{ colorPrimary: classes.whiteText }}
                        className='mt-2'
                      >
                        No captures found. Try clearing any saved filters or hitting "refresh".
                      </Typography>
                      {capturesExhausted &&
                        <Typography
                          variant='h6'
                          color='primary'
                          classes={{ colorPrimary: classes.whiteText }}
                          className='mt-1'
                        >
                          Please use a filter to refine your results.
                        </Typography>}
                    </Grid>
                  </Grid>
                </Paper>
                {/* <ElevioIntegration keywords={['Capture']} /> */}
              </Grid>)
        }
      </Grid>
    </>
  )
}

export default withRouter(CaptureGridView)
